import { Injectable, OnInit } from '@angular/core';
import { Http, RequestOptions } from '@angular/http/';
import { Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AppError } from 'app/common/app-error';
import { NotFoundError } from 'app/common/not-found-error';
import { BadInput } from 'app/common/bad-input';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
//import { AuthHttp } from "angular2-jwt";
//import { SimpleTimer } from 'ng2-simple-timer';

@Injectable()
export class DataService<T> {
	constructor(private url: string, private http: Http) {}

	getAll(): Observable<T[]> {
		let headers = new Headers();
		let token = localStorage.getItem('readToken');
		headers.append('Content-Type', 'application/json');
		headers.append('x-access-token', token);
		let options = new RequestOptions({ headers: headers });
		return this.http.get(this.url, options).map((response) => response.json());
	}

	getValue(valueUrl: string): Observable<T> {
		let headers = new Headers();
		let token = localStorage.getItem('readToken');
		headers.append('Content-Type', 'application/json');
		headers.append('x-access-token', token);
		let options = new RequestOptions({ headers: headers });

		return this.http
			.get(this.url + '/' + valueUrl, options)
			.map((response) => response.json())
			.catch(this.handleError);
	}

	getByValue(valueUrl: string, value: string) {
		let headers = new Headers();
		let token = localStorage.getItem('readToken');
		headers.append('Content-Type', 'application/json');
		headers.append('x-access-token', token);
		let options = new RequestOptions({ headers: headers });

		return this.http
			.get(this.url + '/' + valueUrl + '/' + value, options)
			.map((response) => response.json())
			.catch(this.handleError);
	}
	getByValues(valueUrls: string[], values: string[]) {
		if (valueUrls.length == values.length) {
			var myrequest = this.url;

			for (var i = 0; i < valueUrls.length; i++) {
				myrequest += '/';
				myrequest += valueUrls[i];
				myrequest += '/';
				myrequest += values[i];
			}

			let headers = new Headers();
			let token = localStorage.getItem('readToken');
			headers.append('Content-Type', 'application/json');
			headers.append('x-access-token', token);
			let options = new RequestOptions({ headers: headers });

			return this.http
				.get(myrequest, options)
				.map((response) => response.json())
				.catch(this.handleError);
		}
	}

	create(resource): Observable<number> {
		//simulate error with the following line
		//return Observable.throw(new AppError());
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		let token = localStorage.getItem('readToken');
		let wtoken = localStorage.getItem('token');
		headers.append('x-access-token', token);
		headers.append('x-access-tokenw', wtoken);
		let options = new RequestOptions({ headers: headers });

		return this.http
			.post(this.url, JSON.stringify(resource), { headers: headers })
			.map((response) => response.json())
			.catch(this.handleError);
	}

	update(resource) {
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		let token = localStorage.getItem('readToken');
		let wtoken = localStorage.getItem('token');
		headers.append('x-access-token', token);
		headers.append('x-access-tokenw', wtoken);
		//console.log(JSON.stringify(resource));
		return this.http
			.put(this.url + '/' + resource.id, JSON.stringify(resource), { headers: headers })
			.map((response) => response.json())
			.catch(this.handleError);
	}
	delete(id) {
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		let token = localStorage.getItem('readToken');
		let wtoken = localStorage.getItem('token');
		headers.append('x-access-token', token);
		headers.append('x-access-tokenw', wtoken);
		return this.http
			.delete(this.url + '/' + id, { headers: headers })
			.map((response) => response.json())
			.catch(this.handleError);
	}

	private handleError(error: Response) {
		if (error.status === 404) {
			console.log('error 404');
			return Observable.throw(new NotFoundError());
		}
		if (error.status === 400) return Observable.throw(new BadInput(error.json()));
		if (error.status === 401) return Observable.throw(new BadInput(error.json()));

		return Observable.throw(new AppError(error));
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/data.service.ts